import githubio from "./ws7Q0-removebg-preview.png";
import dsAlgo from "./dsAlgo.png"

const project_images = {
    'githubpages': githubio,
    "dsAlgo": dsAlgo
}

export default project_images;